import { IQuotersPayload } from 'app/models/quoters';
import axiosInstance from './axiosInstance';

const GET_QUOTERS = `/erp/quoters`;

export async function getQuoters(): Promise<{ data: IQuotersPayload[] }> {
	return await axiosInstance.get(GET_QUOTERS);
}
